import React from 'react';
import { Box, Typography } from '@mui/material';
import { formatChatMessageTime } from '../../lib/formatChatTime';

/**
 * Single chat bubble — visitor (right, blue) vs agent/support (left, gray).
 */
export default function ChatMessage({
  message,
  sender,
  senderLabel,
  senderType,
  timestamp,
  variant = 'widget',
  isInternal = false,
}) {
  const isAgent = senderType === 'agent' || sender === 'agent';
  const label = senderLabel || (isInternal ? 'Internal note' : isAgent ? 'Support' : 'You');
  const timeLabel = formatChatMessageTime(timestamp);
  const isAdmin = variant === 'admin';

  return (
    <Box
      className={`chat-message ${isAgent ? 'agent' : 'visitor'}`}
      sx={{
        display: 'flex',
        justifyContent: isAgent ? 'flex-start' : 'flex-end',
        mb: 1.5,
        px: isAdmin ? 0 : 0.5,
      }}
    >
      <Box
        sx={{
          maxWidth: isAdmin ? '78%' : '88%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: isAgent ? 'flex-start' : 'flex-end',
        }}
      >
        <Typography
          variant="caption"
          sx={{
            display: 'block',
            fontWeight: 600,
            fontSize: '0.68rem',
            letterSpacing: '0.02em',
            color: isAgent ? '#64748b' : '#2563eb',
            mb: 0.35,
            px: 0.5,
          }}
        >
          {label}
        </Typography>
        <Box
          sx={{
            px: 1.5,
            py: 1,
            borderRadius: isInternal ? '12px' : isAgent ? '16px 16px 16px 4px' : '16px 16px 4px 16px',
            bgcolor: isInternal ? '#fef3c7' : isAgent ? '#f1f5f9' : '#2563eb',
            color: isInternal ? '#78350f' : isAgent ? '#1e293b' : '#ffffff',
            boxShadow: isInternal
              ? 'inset 0 0 0 1px #fcd34d'
              : isAgent
                ? '0 1px 2px rgba(15, 23, 42, 0.06)'
                : '0 2px 8px rgba(37, 99, 235, 0.28)',
            border: isInternal ? '1px solid #fcd34d' : isAgent ? '1px solid #e2e8f0' : 'none',
          }}
        >
          <Typography
            variant="body2"
            sx={{
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              lineHeight: 1.45,
              fontSize: '0.875rem',
            }}
          >
            {message}
          </Typography>
        </Box>
        {timeLabel ? (
          <Typography
            variant="caption"
            sx={{
              mt: 0.35,
              px: 0.5,
              fontSize: '0.65rem',
              color: '#94a3b8',
            }}
          >
            {timeLabel}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
}
